<div data-test="modal-nome-ja-existe" class="container">
    <mat-toolbar class="header">
        <i class="material-icons icon">info_outline</i>
        <mat-label class="title-header">{{data.title}}</mat-label>
    </mat-toolbar>

    <mat-dialog-content class="content">
        <mat-label class="subtitle">{{data.message}}</mat-label>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class=" footer">
        <button data-test="btn-cancelar-nome-ja-existe" mat-button matDialogClose="no" class="btn-cancel">{{ 'cancel' | translate }}</button>
        <button data-test="btn-confirmar-nome-ja-existe" mat-button matDialogClose="yes" class="btn-confirm">{{ 'confirm' | translate }}</button>
    </mat-dialog-actions>
</div>